<script setup>
import { computed, defineEmits, defineProps } from "vue";
import CustomerSearch from "@/components/CustomerSearch.vue";
import ContactSearch from "@/components/ContactSearch.vue";

const props = defineProps({
  editable: { type: Boolean, required: false },
  customer: { type: Object, required: false },
  customerName: { type: String, required: false },
  contactEmail: { type: String, required: false },
});

const emit = defineEmits(["update:customer", "update:contact"]);

const contactLabel = computed(() => {
  const company = props.customer?.company ?? null;
  const name = props.customerName ?? "";
  const hasDistinctName = name && name !== company;
  if (props.contactEmail && hasDistinctName) {
    return `${name} <${props.contactEmail}>`;
  }
  if (props.contactEmail) return props.contactEmail;
  if (hasDistinctName) return name;
  return "";
});
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block text-xs text-slate-500">Customer</label>
      <CustomerSearch
        v-if="editable"
        :customer="props.customer"
        :resetAfterSelection="false"
        @selected="(val) => emit('update:customer', val)"
      />
      <div v-else class="text-sm text-slate-700 dark:text-slate-200">
        {{ props.customerName ?? "-" }}
      </div>
    </div>
    <div>
      <label class="block text-xs text-slate-500">Contact</label>
      <ContactSearch
        v-if="editable"
        :value="contactLabel"
        :autoShowResults="false"
        :customerId="props.customer?.id"
        @selected="(val) => emit('update:contact', val)"
      />
      <div v-else class="text-sm text-slate-700 dark:text-slate-200">
        {{ props.contactEmail ?? "-" }}
      </div>
    </div>
  </div>
</template>
